export enum AuxDataUITypes {
	normal = 'normal',
	hidden = 'hidden',
	readonly = 'readonly',
}

export interface AuxDataSetCreateRequest {
	auxData: AuxDataCreateRequest[];
}

export interface AuxDataCreateRequest {
	key: string;
	value: string;
	uiType?:
		| AuxDataUITypes.normal
		| AuxDataUITypes.hidden
		| AuxDataUITypes.readonly;
}

export interface AuxDataResponse {
	locator: string;
	key: string;
	value: string;
	uiType:
		| AuxDataUITypes.normal
		| AuxDataUITypes.hidden
		| AuxDataUITypes.readonly;
}

export interface AuxDataKeySetResponse {
	keys: AuxDataKeyResponse[];
	page: number;
}

export interface AuxDataKeyResponse {
	key: string;
	uiType:
		| AuxDataUITypes.normal
		| AuxDataUITypes.hidden
		| AuxDataUITypes.readonly;
}

export type AuxDataEntityTypes =
	| 'quotes'
	| 'policies'
	| 'policyholders'
	| 'exposures'
	| 'perils'
	| 'premiumReports'
	| 'endorsements'
	| 'renewals'
	| 'cancellations'
	| 'reinstatements'
	| 'claims'
	| 'subclaims';
